"use client"
import { ComponentConfig } from "@measured/puck"
import { Input } from "antd"
import { useEffect, useState } from "react"
import { fetchRecruitments } from "../../../../../recruitment/services/recruitment"
import { configs, DefaultImage } from "../../../../external-components"
import { RecruitmentData } from "../../../types"

export type BannerTrangChuProps = {
  imageSrc?: string
  imageMobile?: string
  heading1?: string
  heading2?: string
  inputValue?: string
}

export const RenderConfig: ComponentConfig<BannerTrangChuProps> = {
  render: ({ imageSrc, imageMobile, heading1, heading2, inputValue }: BannerTrangChuProps) => {
    const [value, setValue] = useState("")
    const [data, setData] = useState<string[]>([])
    const [suggestionValue, setSuggestionValue] = useState<string | undefined>(undefined)

    // const router = useRouter()

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value)
    }

    const handleSearch = () => {
      window.location.href = `/tim-kiem?search=${value}`
    }

    const fetchData = async () => {
      try {
        const res = await fetchRecruitments()
        if (res?.data) {
          const titles = new Set(res.data.map((item: RecruitmentData) => item.attributes.Title))
          const departments = new Set(res.data.map((item: RecruitmentData) => item.attributes.Department))
          const company = new Set(res.data.map((item: RecruitmentData) => item.attributes.company))

          const uniqueValues = [...titles, ...departments, ...company].filter(Boolean) as string[]
          setData(uniqueValues)
        }
      } catch (error) {
        console.error("Failed to fetch recruitment data")
      }
    }

    const findSuggestion = (value: string) => {
      if (value) {
        const suggestion = data.find(item => item.toLowerCase().startsWith(value.toLowerCase()))
        setSuggestionValue(suggestion)
      } else {
        setSuggestionValue(undefined)
      }
    }

    const handleKeyDown = (e: { key: string; preventDefault: () => void }) => {
      if (e.key === "Tab" && suggestionValue) {
        e.preventDefault()
        setValue(suggestionValue)
        setSuggestionValue("")
      }
    }

    useEffect(() => {
      fetchData()
    }, [])

    useEffect(() => {
      findSuggestion(value)
    }, [value])

    return (
      <div className="justify-center flex max-sm:pt-[78px] h  ">
        <div className="relative w-full">
          <div className="absolute top-0 left-0 bottom-0 right-0 w-full h-full bg-black opacity-40"></div>
          <img
            className="max-sm:hidden object-cover w-full"
            src={imageSrc ? `${configs.API_URL}${imageSrc}` : DefaultImage}
            alt="Banner Image"
            height={925}
            width={1920}
          />
          <img
            className="md:hidden"
            src={imageMobile ? `${configs.API_URL}${imageMobile}` : DefaultImage}
            alt="Banner Image"
          />
        </div>
        <div className="absolute top-[54.5%] justify-center flex flex-col items-center max-sm:w-full max-sm:top-[27.3%]">
          <div className="max-sm:w-full max-sm:px-[42px]" data-aos="fade-down" data-aos-duration="1000">
            <h1 className="text-[28px] text-white text-center font-bold max-sm:text-[21px] ">{heading1}</h1>
            <h2 className="text-[28px] text-white text-center font-bold max-sm:text-[21px]">{heading2}</h2>
          </div>
          <div
            className="w-full md:w-[768px] max-sm:px-4 justify-center flex max-sm:flex-col max-sm:items-center relative"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <Input
              className={`bg-transparent text-[14px] hover:bg-transparent focus-within:bg-transparent text-white rounded-[50px] 
                  pl-[28px] placeholder:text-white mt-[27px] h-[42px] border-2 border-white hover:border-white focus:border-white focus:border-[1px]
                  max-sm:w-[75%] max-sm:h-[36px]`}
              placeholder={inputValue}
              value={value}
              onChange={handleInputChange}
              onPressEnter={() => handleSearch()}
              onKeyDown={handleKeyDown}
            />
            {suggestionValue && (
              <span
                className={`absolute text-white opacity-70 mt-[38px] text-[14px] pointer-events-none left-[29.5px]`}
              >
                {value + suggestionValue.slice(value.length)}
              </span>
            )}
          </div>

          <p
            className={`text-white rounded-full hover:scale-105 mt-4 !py-2.5 !px-6 transition-all duration-500 cursor-pointer z-10 ${
              value.trim() === "" ? "opacity-0" : "opacity-100"
            }`}
            style={{ background: "linear-gradient(to right top, #5bb97a, #298cca)" }}
            onClick={() => handleSearch()}
          >
            Tìm việc làm
          </p>
        </div>
      </div>
    )
  },
}
